import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withStyles } from "@material-ui/core";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ButtonBase from '@material-ui/core/ButtonBase';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import Typography from '@material-ui/core/Typography';
import StepLabel from '@material-ui/core/StepLabel';
import DataUsage from '@material-ui/icons/DataUsage';
import Run from '@material-ui/icons/PlayArrow';
import Fade from '@material-ui/core/Fade';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';



//-----------------------------------------------------------------



const useStyles = (theme) => ({

    textSytleContent: {
        wordWrap: 'break-word',
        marginTop: 32,
    },

    textSytleTitle: {
        fontWeight: 600,
        marginTop: 96,
    },

    btnClose: {
        marginRight: 24,
        marginTop: 64,
        marginBottom: 24,
        borderRadius:64,
    },

});



//-----------------------------------------------------------------



class WelcomeDialog_ extends Component {
    
  constructor(props) {
    super(props);
  }


  render() {

    const {classes} = this.props;
    
    return (

        <div>

            <Dialog
                open={this.props.openDialogWelcome}
                aria-labelledby="responsive-dialog-title"
                fullWidth={false}
                maxWidth={"md"}>

                    
                    <Box display="flex" style={{width:920}}>

                        <Box style={{width:'42%', minHeight: 420, backgroundColor:"#073f8d", marginRight: 24}} boxShadow={12} >

                            <Grid container alignItems='center' justify = "center" style={{width:'100%', height:'100%'}}>
                                <img style={{width:'70%', height:'96%'}} fill="#000000" alt="complex" src={"./res/images/object_white.png"}/>
                            </Grid>

                        </Box>

                        <Box style={{width:'58%', minHeight: 420, backgroundColor:'#FFFFFF'}}>

                            <Box style={{marginLeft: 12, marginTop: 32, marginRight: 32}}>
                            
                                <Typography component="h3" variant="h3" style={{marginBottom:16}} className={classes.textSytleTitle}>
                                    Welcome!
                                </Typography>

                                <Typography variant="subtitle1" color="textSecondary" className={classes.textSytleContent}>
                                    Welcome to our CT Parameter Simulation site! On this site you can vary different CT simulation parameters to determine the best set of parameters for your particular use case. On the left, you can change source-, detector- and object parameters. On the right, you can see a subset of the simulated projection images as a preview. Enjoy!
                                </Typography>

                            </Box>

                            <Grid container
                                direction="row">

                                <Grid item container xs={12} justify={"flex-end"}>

                                    <Button
                                        className={classes.btnClose}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => { this.props.onCloseDialog() }}
                                    > Close </Button>

                                </Grid>

                            </Grid>

                        </Box>

                    </Box>


            </Dialog>

      </div>

    );

  }

}



//-----------------------------------------------------------------



const mapStateToProps = (state, props) => {

    return {
        openDialogWelcome: state.interaction.openDialogWelcome,

    };

}

const mapDispatchToProps = (dispatch, props) => {

    return {
        onCloseDialog: () => { dispatch({ type: "DIALOG:WELCOME-CLOSE" }) },
    };
  
}


const WelcomeDialog = connect(mapStateToProps, mapDispatchToProps)(WelcomeDialog_)
export default withStyles(useStyles) (WelcomeDialog);
